import { useSelector } from "react-redux";
import cuisinier from "../../assets/IMG_5263.jpg";
import { t } from "../../translations";
import "../styles/what-is-pani.css";

const WhatIsPani = () => {
  const lang = useSelector((state) => state.lang);

  return (
    <div className="section-description-pani">
      <img src={cuisinier} alt="" />
      <div className="text-description">
        <hr />
        <h2>{t("content.what_is_pani_title", lang)}</h2>
        <hr />
        <p
          dangerouslySetInnerHTML={{
            __html: t("what_is_pani.description", lang)
          }}
        />
      </div>
    </div>
  );
};

export default WhatIsPani;
